/**
 * Project: spaces
 * File: AssetHelper
 * Created by Pennycodes on 2/4/2022.
 * Copyright spaces
 */
export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
